import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BRAND = /^(apmercl|apmerc|apmerclcom|wwwapmerclcom)$/i;

export default function BrandJump() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const q = new URLSearchParams(location.search).get("q");
    if (q == null) return;
    const key = q.trim().toLowerCase().replace(/[^a-z0-9]+/g, "");
    if (!key || BRAND.test(key)) {
      navigate({ pathname: "/", search: "" }, { replace: true });
    }
  }, [location.search, navigate]);

  return null;
}
